import React, { FC } from "react";
import { Button } from "../../atoms/Button";
import { Container, SubTitle, Title, Wrapper, Image, Text } from "./elements";
import not_found from "../../../assets/images/not_found.svg";

type Props = {
  title: string;
  subTitle: string;
  onClick: () => void;
  buttonText: string;
  text: string;
};

const PageNotFound: FC<Props> = (props) => {
  const { title, subTitle, onClick, buttonText, text } = props;

  return (
    <Wrapper>
      <Container>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
        <Image src={not_found} alt="not found img" />
        <Text>{text}</Text>
        <Button type={"primary"} onClick={onClick}>
          {buttonText}
        </Button>
      </Container>
    </Wrapper>
  );
};

export default PageNotFound;
